import * as React from 'react';

function SvgHappyEmoji(props) {
  return (
    <svg viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z"
        fill="#FED132"
        stroke="#4F4F4F"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M18.296 16.953c-.494 1.941-2.718 3.388-5.365 3.388-2.612 0-4.835-1.447-5.365-3.353"
        stroke="#4F4F4F"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M16.706 11.059a1.235 1.235 0 1 0 0-2.47 1.235 1.235 0 0 0 0 2.47ZM9.294 11.059a1.235 1.235 0 1 0 0-2.47 1.235 1.235 0 0 0 0 2.47Z"
        fill="#4F4F4F"
      />
    </svg>
  );
}
export default SvgHappyEmoji;
